import React from 'react';
import { FacebookIcon, TwitterIcon, InstagramIcon, LinkedinIcon, MailIcon, PhoneIcon, MapPinIcon } from 'lucide-react';
import { Logo } from './Logo';
export function Footer() {
  return <footer className="bg-gray-950 text-gray-300 pt-16 pb-8 border-t border-gray-800" data-id="element-346" data-mp="32onj8zjvni7d">
      <div className="w-full px-[clamp(16px,3vw,64px)]" data-id="element-347" data-mp="36oxzd51dvozy">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-348" data-mp="36nd4tff2k623">
          {/* Company Info */}
          <div className="lg:col-span-1" data-id="element-349" data-mp="3ud7czjog16g0">
            <a href="#" className="inline-flex items-center mb-6 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-red-600 focus-visible:ring-offset-4 focus-visible:ring-offset-gray-950" data-id="element-350" data-mp="37o56rpk5rbs">
              <Logo variant="dark" size="sm" data-id="element-351" data-mp="3qf9sgu5mb8iy" />
            </a>
            <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-352" data-mp="29ydxc2mb78ay">
              Marketing Experts at Driving & Turning Traffic into Conversions
              with a Focus on Building Customer Loyalty & Retention.
            </p>
            <div className="space-y-3 text-sm" data-id="element-353" data-mp="3lbdd6ucasbmc">
              <a href="tel:17022134801" className="flex items-center hover:text-white transition-colors" data-id="element-354" data-mp="3gbinuv867u3e">
                <PhoneIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-355" data-mp="3v5dh4svufath" />
                (702) 213-4801
              </a>
              <a href="mailto:Results@GetAdROI.com" className="flex items-center hover:text-white transition-colors" data-id="element-356" data-mp="82qtvx6261vu">
                <MailIcon className="w-4 h-4 mr-3 text-gray-500" data-id="element-357" data-mp="31upzjlpifqf" />
                Results@GetAdROI.com
              </a>
              <div className="flex items-start" data-id="element-358" data-mp="ctqo2unsm5un">
                <MapPinIcon className="w-4 h-4 mr-3 text-gray-500 mt-1 flex-shrink-0" data-id="element-359" data-mp="cv1qaq1lb5jn" />
                <span data-id="element-360" data-mp="qujm3pdazj2i">
                  4730 S. Fort Apache Rd., Suite 300
                  <br data-id="element-361" data-mp="msg8ov72q4el" />
                  Las Vegas, NV 89147
                </span>
              </div>
            </div>
          </div>

          {/* Services */}
          <div data-id="element-362" data-mp="tt09ssljiqrj">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-363" data-mp="yu7geoby5jwm">
              Services
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-364" data-mp="13t0uahv5bcxb">
              <li data-id="element-365" data-mp="13r7mv0cpkoo9">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-366" data-mp="18k0qfkwfxqyr">
                  Search Engine Optimization
                </a>
              </li>
              <li data-id="element-367" data-mp="1cl2r8660ab2u">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-368" data-mp="1cnoye4oziokj">
                  Pay-Per-Click Advertising
                </a>
              </li>
              <li data-id="element-369" data-mp="1mktp8htrz87o">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-370" data-mp="1mkbiusdefdm1">
                  Web Design & Development
                </a>
              </li>
              <li data-id="element-371" data-mp="3obokn8k2l5dv">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-372" data-mp="3oc6oorcz4nwc">
                  CRM Implementation
                </a>
              </li>
              <li data-id="element-373" data-mp="2af3qtkngqtgz">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-374" data-mp="2afnb380l5ty6">
                  Conversion Rate Optimization
                </a>
              </li>
              <li data-id="element-375" data-mp="25mao12bk1v7j">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-376" data-mp="21mtjcb3yd23f">
                  Social Media Marketing
                </a>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div data-id="element-377" data-mp="2tehoodobcocr">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-378" data-mp="2tcy8en2nqdaz">
              Company
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-379" data-mp="2pd5x42lvpt1x">
              <li data-id="element-380" data-mp="2kd1i6h0md6dt">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-381" data-mp="2kc8ghugip72j">
                  About Us
                </a>
              </li>
              <li data-id="element-382" data-mp="2fgay7ilp1qn4">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-383" data-mp="18y4p8w1bdx16">
                  Our Process
                </a>
              </li>
              <li data-id="element-384" data-mp="13y9xyrdmn5fl">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-385" data-mp="13xqcx1sok0xc">
                  Case Studies
                </a>
              </li>
              <li data-id="element-386" data-mp="2wmzhkd8g0dtk">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-387" data-mp="2wnhmdy9680d3">
                  Careers
                </a>
              </li>
              <li data-id="element-388" data-mp="2isyh9f1ueir3">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-389" data-mp="2nu5ptgbt7lyt">
                  Contact
                </a>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div data-id="element-390" data-mp="3flbv0b6e09uy">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-391" data-mp="3fltwbm7wpe9q">
              Resources
            </h4>
            <ul className="space-y-3 text-sm mb-6" data-id="element-392" data-mp="31kr93656dxx8">
              <li data-id="element-393" data-mp="36kdmbfl07e61">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-394" data-mp="36jug2w4pue7u">
                  Marketing Blog
                </a>
              </li>
              <li data-id="element-395" data-mp="1q8go3lwob63c">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-396" data-mp="1v5gu5wtiw8ug">
                  ROI Calculator
                </a>
              </li>
              <li data-id="element-397" data-mp="1nkmq8dypcr7j">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-398" data-mp="1nk4myxdmhcq4">
                  Free SEO Audit
                </a>
              </li>
              <li data-id="element-399" data-mp="1wn5qcqb3spq3">
                <a href="#" className="hover:text-red-500 transition-colors" data-id="element-400" data-mp="1wlky57c9hive">
                  Help Center
                </a>
              </li>
            </ul>
            <h4 className="text-white font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-401" data-mp="13xyl78h591vv">
              Follow Us
            </h4>
            <div className="flex space-x-4" data-id="element-402" data-mp="zx6b6d0g6syj">
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-403" data-mp="zuabok8ybw7z">
                <FacebookIcon className="w-5 h-5" data-id="element-404" data-mp="18wjk94kntfiq" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-405" data-mp="18v8gv5v4m9s5">
                <TwitterIcon className="w-5 h-5" data-id="element-406" data-mp="g8xebpnylysp" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-407" data-mp="g6jktl8xgun9">
                <InstagramIcon className="w-5 h-5" data-id="element-408" data-mp="2l8yhean9zthf" />
              </a>
              <a href="#" className="text-gray-400 hover:text-white transition-colors" data-id="element-409" data-mp="2q0ghkwhh5q1c">
                <LinkedinIcon className="w-5 h-5" data-id="element-410" data-mp="2uyi11iitbrdc" />
              </a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-xs text-gray-500" data-id="element-411" data-mp="1xd2rnic71uqq">
          <p data-id="element-412" data-mp="22cp6txbl1l26">
            &copy; {new Date().getFullYear()} AdROI Marketing & Conversions. All
            rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-413" data-mp="2bbsrv6ub8ajb">
            <a href="#" className="hover:text-white transition-colors" data-id="element-414" data-mp="2b97naa2mnghv">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-415" data-mp="3mqplku1fvnx0">
              Terms of Service
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-416" data-mp="1b3vuha9o78d0">
              Cookie Policy
            </a>
          </div>
        </div>

        <div className="mt-6 flex flex-col items-center gap-1 text-center text-xs text-gray-500 sm:flex-row sm:justify-center sm:gap-3" data-id="element-417" data-mp="172k95gxtx9am">
          <span data-id="element-418" data-mp="xc7f8y44k3rt">Website Design, Marketing by Ad ROI Marketing</span>
          <span aria-hidden="true" className="hidden text-gray-700 sm:inline" data-id="element-419" data-mp="x9v2r0h4ylm5">
            |
          </span>
          <span data-id="element-420" data-mp="sai4zkoq7u4s">Sales Automation CRM by 1Dash.Pro</span>
        </div>
      </div>
    </footer>;
}